
import { useState, useEffect } from 'react';

const WhatsAppButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 1000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <a
      href="https://wa.me/34602365996"
      target="_blank"
      rel="noopener noreferrer"
      className={`fixed bottom-6 right-6 z-40 w-14 h-14 flex items-center justify-center bg-accent text-white rounded-full shadow-lg hover:scale-110 transition-all duration-300 cursor-pointer group ${
        isVisible ? 'animate-bounce' : 'opacity-0'
      }`}
      aria-label="Contactar por WhatsApp"
    >
      <i className="fab fa-whatsapp text-3xl"></i>
      <span className="absolute right-16 bg-gray-900 text-white text-sm px-3 py-2 rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
        Escríbenos por WhatsApp
      </span>
    </a>
  );
};

export default WhatsAppButton;
